// extracted by mini-css-extract-plugin
export default {"hero__img":"carousel_hero__img__MnjwL"};